import '../../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../../node_modules/lit-element/lit-element.js';
import { css as r } from '../../../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = r`.mac-ff span{padding-top:3px!important}.win-ff .primary-button,.win-ff span{padding-top:6px!important}`;

export { css_248z as default };
